import styled from '@emotion/styled'
import { css } from '@emotion/react'

const containerStyles = ({ color }) => css`
  label: timeline__item;

  display: flex;

  width: 80px;

  flex-wrap: wrap;
  justify-content: center;
  text-align: center;

  z-index: 2;
  color: ${color};
`

const circleStyles = ({ theme }) => css`
  label: timeline__item-circle;

  display: flex;

  align-items: center;
  justify-content: center;

  height: 60px;
  width: 60px;

  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.circle};
  border: 4px solid currentColor;
`

export const Container = styled('li')(containerStyles)
export const Circle = styled('div')(circleStyles)
